module.exports = __webpack_public_path__ + "static/media/1014372.3574c080.jpg";